import { CrossClientQueryExecution, CrossClientQueryExecutionProgress, CrossClientQueryPhase, CrossClientQueryPhases } from '../../models/CrossClient'

export const CROSS_EXECUTION_CLIENT_RUNNING_PHASES: Set<CrossClientQueryPhase> = new Set([
  CrossClientQueryPhases.INITIALIZED,
  CrossClientQueryPhases.LOCAL_READY,
  CrossClientQueryPhases.LOCAL_QUEUED,
  CrossClientQueryPhases.LOCAL_PROCESSING,
  CrossClientQueryPhases.AI_READY,
  CrossClientQueryPhases.AI_QUEUED,
  CrossClientQueryPhases.AI_PROCESSING,
  CrossClientQueryPhases.AI_STOPPED,
  CrossClientQueryPhases.CANCELING,
])

export const CROSS_EXECUTION_CLIENT_PROCESSING_PHASES: Set<CrossClientQueryPhase> = new Set([
  CrossClientQueryPhases.LOCAL_QUEUED,
  CrossClientQueryPhases.LOCAL_PROCESSING,
  CrossClientQueryPhases.AI_QUEUED,
  CrossClientQueryPhases.AI_PROCESSING,
  CrossClientQueryPhases.CANCELING,
])

export const CROSS_EXECUTION_CLIENT_FINISHED_PHASES: Set<CrossClientQueryPhase> = new Set([CrossClientQueryPhases.COMPLETED, CrossClientQueryPhases.CANCELED])

export const executionIsRunning = (execution?: CrossClientQueryExecution | CrossClientQueryExecutionProgress | null) => {
  return !!execution && CROSS_EXECUTION_CLIENT_RUNNING_PHASES.has(execution.phase)
}
